import { FC } from 'react'

import { Page, PageContent } from 'common'
import { Loader, ErrorHandler, Header, PrivacyPolicyLink, CustomBabi } from 'components'
import { Routes } from 'common/constants'
import { Link, ScrollRestoration } from 'react-router-dom'
import { map } from 'lodash'
import { Button } from 'common/styles/layouts'

import { Text } from '@interco/inter-ui/components/Text'
import IcChevronRight from '@interco/icons/core/action-navigation/ic_chevron_right'

import { ReportCard } from './report-card/ReportCard'
import { DescriptionArea, ReportCardsArea } from './styles'
import { useYourPersonalData } from '../hooks/useYourPersonalData'

export const YourPersonalData: FC = () => {
  const {
    title,
    subtitle,
    descriptionList,
    reportHistoryButton,
    reportCards,
    isErrorOrInactive,
    traceDetails,
    isHystoryButtonHidden,
    isAppLoading,
  } = useYourPersonalData()

  if (isAppLoading) return <Loader />

  if (isErrorOrInactive) {
    return <ErrorHandler traceDetails={traceDetails} componentName={YourPersonalData.name} />
  }
  return (
    <Page>
      <Header title={title} goToPath={Routes.HOME} />
      <PageContent gap={24}>
        <DescriptionArea>
          <Text variant="headline-h2" color="typography" colorWeight={500} as="p" semiBold>
            {subtitle}
          </Text>
          {descriptionList.map((description) => (
            <Text variant="body-3" color="typography" as="p">
              {description}
            </Text>
          ))}
        </DescriptionArea>
        {!isHystoryButtonHidden && (
          <Link to={Routes.REPORTS_HISTORY}>
            <Button
              size="small"
              variant="secondary"
              fullWidth
              icon={<IcChevronRight height={24} width={24} color="var(--secondary500)" />}
            >
              {reportHistoryButton}
            </Button>
          </Link>
        )}
        <ReportCardsArea>
          {map(reportCards, (reportCard) => {
            if (!reportCard.isActive) return null

            return <ReportCard key={reportCard.type} {...reportCard} />
          })}
        </ReportCardsArea>
        <PrivacyPolicyLink />
        <CustomBabi />
        <ScrollRestoration />
      </PageContent>
    </Page>
  )
}
